export const PAYMENT_INFO_DELAY = 1000;
